<article>
  <div class="data-field half machine">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.MACHINE' | bmsTranslate: {count: 1} }}</label>
    <p class="b2"><vdw-ellipsis-label [text]="machine().name"></vdw-ellipsis-label></p>
  </div>

  <div class="data-field half creel">
    <label class="b2">{{ 'TEXTILE_DATA.CREEL.ENTITY' | bmsTranslate }}</label>
    <p *ngIf="parentRun().creel; else notApplicable" class="b2">
      {{ parentRun().creel.name }}
    </p>
  </div>
  <div class="data-field half quality">
    <label class="b2">{{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} }}</label>
    <p *ngIf="parentRun().quality; else notApplicable" class="b2">
      {{ parentRun().quality.name }}
    </p>
  </div>

  <div class="data-field startDate">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.START_DATE' | bmsTranslate }}</label>
    <p class="b2">{{ placeholder().actualStartDate ?? forecast().estimatedStart | DateTime: 'DATETIME_MED_WITH_WEEKDAY' }}</p>
  </div>
  <div class="data-field endDate">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.END_DATE' | bmsTranslate }}</label>
    <p *ngIf="placeholder().actualEndDate; else notApplicable" class="b2">
      {{ placeholder().actualEndDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY' }}
    </p>
  </div>
  <div class="data-field estimatedEndDate">
    <label class="b2">{{ 'PLANNING.PLANNING_ORDER_FIELDS.ESTIMATED_END_DATE' | bmsTranslate }}</label>
    <p class="b2">
      {{ forecast()?.estimatedEnd ?? placeholder().estimatedEndDate ?? placeholder().actualEndDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY' }}
    </p>
  </div>

  <ng-template #notApplicable>
    <p class="b2">n/a</p>
  </ng-template>
</article>

@if (placeholder().fixedSchedule.productionOrder) {
  <footer>
    @if (!placeholder().actualStartDate) {
      <button mat-stroked-button type="button" (click)="delete()">
        {{ 'PLANNING.ACTIONS.REMOVE' | bmsTranslate }}
      </button>
    }
  </footer>
}
